import { createAction } from "@reduxjs/toolkit";

export enum LoadingState {
  NOT_STARTED,
  IDLE,
  LOADING,
  SUCCEEDED,
  FAILED
}

export const resetState = createAction("RESET_STATE");
